import styled from 'styled-components'
import Textfield from 'syf-component-library/ui/atoms/Textfield'
import { colors } from 'theme'

interface RulesContainerProps {
  showRulesContainer?: boolean
}

const RulesContainer = styled.div<RulesContainerProps>`
  margin-bottom: ${p => (p.showRulesContainer ? '10px' : '0px')};
  width: 100%;
  max-width: 290px;
  background-color: ${colors.weissThree};
  border-radius: 0.25em 0.25em 0.25em 0.25em;
  overflow: hidden;
  transition: max-height 1s linear;
  max-height: ${p => (p.showRulesContainer ? '350px' : '0px')};
`

const TextfieldWithMargin = styled(Textfield)`
  margin-bottom: 10px;
`

export { RulesContainer, TextfieldWithMargin }
